const loadingMessages = [
  "前世の記憶をスキャン中...",
  "顔の骨格から時代を特定中...",
  "あなたの前世の部屋を構築中...",
  "高画質でレンダリング中... もう少しお待ちください！"
];
let loadingInterval;

// GAS URL 유지
const GAS_WEB_APP_URL = "https://script.google.com/macros/s/AKfycbzGWRARqh0gtzSBOuHUa94pBCrR8E85579ngWbviA5ubLq_6an-YI1a6TOqHzySm_mrVA/exec";

// 하루 1회 체크 함수 (현재 시크릿모드 테스트 중이시면 아래에서 주석 처리해두세요)
function checkDailyLimit() {
  const today = new Date().toLocaleDateString('ja-JP');
  const lastUsed = localStorage.getItem('pr_last_used_date');
  if (lastUsed === today) {
    alert("本日のご利用上限（1回）に達しました。また明日お試しください！");
    return false;
  }
  return true;
}

async function handleImageUpload(event) {
  // 🚨 [추가 1] 비회원 원천 차단! (파이어베이스 용량 낭비 방지)
  if (!window.ShopifyInfo || !window.ShopifyInfo.currentUserId || window.ShopifyInfo.currentUserId === "Guest") {
      alert("FACE to ROOMは会員限定の機能です！🎁\nログイン（または無料会員登録）して前世のお部屋をチェックしましょう！");
      window.location.href = (window.ShopifyInfo && window.ShopifyInfo.loginUrl) ? window.ShopifyInfo.loginUrl : "/account/login";
      event.target.value = ""; // 파일 선택한 거 초기화
      return; // 여기서 함수 완전 종료
  }

  const file = event.target.files[0];
  if (!file) return;

  // 💡 [기존] 파이어베이스 스토리지에 원본 이미지 저장 시도
  try {
    const storage = firebase.storage();
    const storageRef = storage.ref();
    const uniqueFileName = `original_uploads/${Date.now()}_${Math.random().toString(36).substr(2, 9)}_${file.name}`;
    const uploadTask = storageRef.child(uniqueFileName).put(file);

    uploadTask.on('state_changed', 
      (snapshot) => { /* 업로드 진행상황 */ }, 
      (error) => { console.error("파이어베이스 업로드 실패:", error); }, 
      () => { console.log("원본 이미지 파이어베이스 저장 성공:", uniqueFileName); }
    );
  } catch (e) {
    console.warn("파이어베이스가 초기화되지 않았거나 오류 발생:", e);
  }

  document.getElementById('uploadSection').style.display = 'none';
  document.getElementById('loadingSection').style.display = 'flex';
  
  let msgIndex = 0;
  const textEl = document.getElementById('loadingText');
  loadingInterval = setInterval(() => {
    msgIndex = (msgIndex + 1) % loadingMessages.length;
    textEl.innerText = loadingMessages[msgIndex];
  }, 2000);

  const reader = new FileReader();
  reader.onload = async function() {
    const base64Image = reader.result;
    try {
      const response = await fetch(GAS_WEB_APP_URL, {
        method: 'POST', 
        headers: { 'Content-Type': 'text/plain;charset=utf-8' }, 
        redirect: 'follow', 
        // 🚨 유저 정보 같이 포장해서 보내기
        body: JSON.stringify({ 
          image: base64Image,
          featureName: "FACE to ROOM",
          userId: window.ShopifyInfo.currentUserId,
          userName: window.ShopifyInfo.currentUser
        })
      });
      const data = await response.json();

      // 🚨 [추가 2] 서버(GAS)에서 "이 ID 오늘 이미 썼음!" 하고 빠꾸먹였을 때
      if ((data.success === false || data.status === "error") && data.message === "LIMIT_EXCEEDED") {
          clearInterval(loadingInterval);
          alert("本日のご利用上限（1回）に達しました。\nまた明日お試しください！📸 (サーバー確認済み)");
          resetPage();
          return; // 여기서 컷!
      }

      if (data.status !== "success") throw new Error(data.message);
      
      clearInterval(loadingInterval);
      
      document.getElementById('tagsDisplay').innerText = data.hashtags;
      document.getElementById('generatedImage').src = data.imageUrl; 
      document.getElementById('loadingSection').style.display = 'none';
      document.getElementById('resultSection').style.display = 'flex';

    } catch (error) {
      console.error("AI API 통신 에러:", error);
      clearInterval(loadingInterval);
      alert('AI 生成中にエラーが発生しました。もう一度お試しください。');
      resetPage();
    }
  };
  reader.readAsDataURL(file);
}

// 💡 네이티브 공유 로직 (인스타그램/카톡 등 폰 기본 공유창 호출)
async function shareToInstagram() {
  const captureArea = document.getElementById('captureArea');
  const shareBtn = document.querySelector('.pr-btn-share');
  const originalText = shareBtn.innerHTML;
  
  shareBtn.innerText = "準備中...";
  shareBtn.disabled = true;

  try {
    const canvas = await html2canvas(captureArea, { scale: 2, useCORS: true, backgroundColor: "#ffffff" });
    
    canvas.toBlob(async (blob) => {
      const file = new File([blob], `FRNHT_Past_Life_${Date.now()}.png`, { type: "image/png" });

      if (navigator.canShare && navigator.canShare({ files: [file] })) {
        try {
          await navigator.share({
            files: [file],
            title: 'PAST LIFE ROOM',
            text: 'Furnihunterで見つけた私の前世の部屋！'
          });
        } catch (err) {
          console.log('シェアがキャンセルされました');
        }
      } else {
        alert("お使いの端末は直接シェアに対応していません。画像を保存しましたので、Instagramなどから投稿してください！");
        saveImage(); 
      }
      
      shareBtn.innerHTML = originalText;
      shareBtn.disabled = false;
    }, "image/png");

  } catch (err) {
    console.error("シェア エラー:", err);
    alert("エラーが発生しました。");
    shareBtn.innerHTML = originalText;
    shareBtn.disabled = false;
  }
}

// 💡 강력한 다운로드 & 우회 저장 함수 (로딩 오버레이 + 성공 UX 추가)
async function saveImage() {
  const captureArea = document.getElementById('captureArea');
  const saveBtn = document.querySelector('.pr-btn-save');
  const originalText = saveBtn.innerText;
  
  // 1️⃣ 화면 전체를 덮는 검은색 반투명 로딩 오버레이 생성
  const loadingOverlay = document.createElement('div');
  loadingOverlay.id = 'saveLoadingOverlay';
  loadingOverlay.style.position = 'fixed';
  loadingOverlay.style.top = '0';
  loadingOverlay.style.left = '0';
  loadingOverlay.style.width = '100vw';
  loadingOverlay.style.height = '100vh';
  loadingOverlay.style.backgroundColor = 'rgba(0,0,0,0.7)'; // 검은색 반투명 배경
  loadingOverlay.style.zIndex = '9999';
  loadingOverlay.style.display = 'flex';
  loadingOverlay.style.flexDirection = 'column';
  loadingOverlay.style.alignItems = 'center';
  loadingOverlay.style.justifyContent = 'center';
  loadingOverlay.style.color = '#fff';

  // 스피너 애니메이션과 일본어 텍스트 추가
  loadingOverlay.innerHTML = `
    <style>
      @keyframes spin { 0% { transform: rotate(0deg); } 100% { transform: rotate(360deg); } }
      .fh-save-spinner {
        border: 4px solid rgba(255,255,255,0.2);
        border-top: 4px solid #fff;
        border-radius: 50%;
        width: 45px;
        height: 45px;
        animation: spin 1s linear infinite;
        margin-bottom: 20px;
      }
    </style>
    <div class="fh-save-spinner"></div>
    <div style="font-size: 16px; font-weight: bold; letter-spacing: 1px;">保存中です...</div>
    <div style="font-size: 13px; margin-top: 8px; opacity: 0.8;">しばらくお待ちください</div>
  `;
  document.body.appendChild(loadingOverlay);

  try {
    // 🚨 중요: 로딩 화면이 브라우저에 뜰 수 있도록 0.1초 잠깐 대기
    await new Promise(resolve => setTimeout(resolve, 100));

    // html2canvas 실행 (이미지 굽기)
    const canvas = await html2canvas(captureArea, { 
      scale: 2, 
      useCORS: true, 
      backgroundColor: "#ffffff" 
    });
    
    const dataUrl = canvas.toDataURL('image/png');
    const fileName = `FRNHT_Past_Life_${Date.now()}.png`;

    const link = document.createElement('a');
    link.download = fileName;
    link.href = dataUrl;
    
    const event = new MouseEvent('click', { view: window, bubbles: true, cancelable: true });
    const clicked = link.dispatchEvent(event);

    // 2️⃣ 다운로드 완료 후 로딩 오버레이 제거
    if (document.getElementById('saveLoadingOverlay')) {
      document.body.removeChild(loadingOverlay);
    }

    // 인앱 브라우저 (카톡/인스타 등) 우회 로직
    if (!clicked || navigator.userAgent.includes("Instagram") || navigator.userAgent.includes("KAKAOTALK")) {
       alert("ご利用のブラウザでは直接ダウンロードできません。表示される画像を長押し（または右クリック）して保存してください！");
       
       const inappOverlay = document.createElement('div');
       inappOverlay.style.position = 'fixed';
       inappOverlay.style.top = '0'; inappOverlay.style.left = '0';
       inappOverlay.style.width = '100vw'; inappOverlay.style.height = '100vh';
       inappOverlay.style.backgroundColor = 'rgba(0,0,0,0.9)';
       inappOverlay.style.zIndex = '9999';
       inappOverlay.style.display = 'flex';
       inappOverlay.style.flexDirection = 'column';
       inappOverlay.style.alignItems = 'center';
       inappOverlay.style.justifyContent = 'center';
       
       const img = document.createElement('img');
       img.src = dataUrl;
       img.style.maxWidth = '90%';
       img.style.maxHeight = '80%';
       img.style.borderRadius = '10px';
       
       const closeText = document.createElement('p');
       closeText.innerText = "画像を長押し（右クリック）して保存 / タップして閉じる";
       closeText.style.color = '#fff';
       closeText.style.marginTop = '20px';
       closeText.style.fontWeight = 'bold';
       
       inappOverlay.appendChild(img);
       inappOverlay.appendChild(closeText);
       inappOverlay.onclick = () => document.body.removeChild(inappOverlay);
       document.body.appendChild(inappOverlay);
       return; // 인앱 브라우저면 여기서 함수 종료
    }

    // 3️⃣ 정상 다운로드 성공 시 버튼 초록색으로 찰진 피드백!
    saveBtn.innerHTML = "保存完了！ ✅";
    saveBtn.style.backgroundColor = "#4CAF50"; 
    saveBtn.style.color = "#ffffff";
    saveBtn.style.borderColor = "#4CAF50";

    setTimeout(() => {
      saveBtn.innerHTML = originalText;
      saveBtn.style.backgroundColor = ""; 
      saveBtn.style.color = "";
      saveBtn.style.borderColor = "";
    }, 3000);

  } catch (err) {
    console.error("画像保存エラー:", err);
    // 에러 났을 때도 로딩 오버레이는 확실하게 지워줌
    if (document.getElementById('saveLoadingOverlay')) {
      document.body.removeChild(loadingOverlay);
    }
    alert("画像の保存に失敗しました。");
  } 
}

function resetPage() {
  document.getElementById('imageInput').value = "";
  if (document.getElementById('tagsDisplay')) document.getElementById('tagsDisplay').innerText = "";
  
  document.getElementById('resultSection').style.display = 'none';
  
  // 🚨 [추가된 부분] 로딩창(스피너)을 확실하게 숨겨서 무한 로딩 방지!
  document.getElementById('loadingSection').style.display = 'none'; 
  
  document.getElementById('uploadSection').style.display = 'flex';
}